export class ParserContentData {
  /**
   * Получение группы
   * @param data - данные
   * @param groupKey - ключ группы
   */
  static getGroup(data = {}, { groupKey = '' } = {}) {
    return data && data[groupKey] ? data[groupKey] : {};
  }

  /**
   * Получение блоков
   * @param data - данные
   * @param groupKey - ключ группы
   */
  static getBlocks(data, { groupKey } = {}) {
    const group = ParserContentData.getGroup(data, { groupKey });
    return group && group.blocks ? group.blocks : {};
  }

  /**
   * Получение блоков в виде массива
   * @param data - данные
   * @param groupKey - ключ группы
   */
  static getBlocksArray(data, { groupKey } = {}) {
    const blocks = ParserContentData.getBlocks(data, { groupKey });
    return Object.values(blocks);
  }

  /**
   * Получение конркетного блока из группы
   * @param data - данные
   * @param groupKey - ключ группы
   * @param blockKey - ключ блока
   */
  static getBlock(data, { groupKey, blockKey = '' } = {}) {
    const blocks = ParserContentData.getBlocks(data, { groupKey });

    return blocks[blockKey] || {};
  }

  /**
   * Получение записей из конкретного блока
   * @param data - данные
   * @param groupKey - ключ группы
   * @param blockKey - ключ блока
   */
  static getItems(data, { groupKey, blockKey = '' } = {}) {
    const block = ParserContentData.getBlock(data, { groupKey, blockKey });

    return block.items || {};
  }

  /**
   * Получение записей в виде массива
   * @param data - данные
   * @param groupKey - ключ группы
   * @param blockKey - ключ блока
   */
  static getItemsArray(data, { groupKey, blockKey } = {}) {
    const items = ParserContentData.getItems(data, { groupKey, blockKey });

    return Object.values(items);
  }

  /**
   * Получение записей в виде массива из блока (при запросе блока, а не группы)
   * @param data - данные
   * @param blockKey ключ блока
   */
  static getItemsArrayFromBlock(data, { blockKey } = {}) {
    const block = data && data[blockKey] ? data[blockKey] : {};
    const items = block.items || {};

    return Object.values(items);
  }

  /**
   * Получение записей в виде массива из всех блоков группы
   * @param data - данные
   * @param groupKey - ключ группы
   */
  static getItemsArrayFromAllBlock(data, { groupKey } = {}) {
    const blocks = ParserContentData.getBlocksArray(data, { groupKey });

    return blocks.reduce((acc, item) => {
      if (item.items) {
        acc.push(...Object.values(item.items));
      }

      return acc;
    }, []);
  }

  /**
   * Получение конретной записи
   * @param data - данные
   * @param groupKey - ключ группы
   * @param blockKey - ключ блока
   * @param itemKey - ключ записи
   */
  static getItem(data = {}, { groupKey, blockKey, itemKey = '' } = {}) {
    const block = ParserContentData.getBlock(data, { groupKey, blockKey });

    return block.items && block.items[itemKey] ? block.items[itemKey] : {};
  }

  /**
   * Получение данных из записи
   * @param data - данные
   * @param groupKey - ключ группы
   * @param blockKey - ключ блока
   * @param itemKey - ключ записи
   */
  static getItemData(data, { groupKey, blockKey, itemKey } = {}) {
    const item = ParserContentData.getItem(data, { groupKey, blockKey, itemKey });

    return ParserContentData.getDataFromItem(item);
  }

  /**
   * Возвращает данные для записи
   * @param item - запись
   */
  static getDataFromItem(item = {}) {
    const data = item ? item : {};
    return {
      id: data.id || '',
      alias: data.alias || '',
      formData: data.form_data || {},
    };
  }
}
